import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
const LoadableRedux = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "adopts_seller_shared" */ '../redux/SellerModuleLoader')));
const LoadableModal = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "adopts_seller_shared" */ './SellerModal')));
const SellerModalLoadable = (props)=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "SellerModalLoadable"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama',
            withOverlay: true,
            usePortal: true
        })
    }, /*#__PURE__*/ React.createElement(LoadableRedux, null), /*#__PURE__*/ React.createElement(LoadableModal, props)));
SellerModalLoadable.displayName = 'SellerModalLoadable';
export default SellerModalLoadable;

//# sourceMappingURL=SellerModalLoadable.js.map